import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Link, useRouteMatch } from "react-router-dom";
import './SubMenu.css';

function ConnectedSubMenu({ label, style, to, or = null, activeOnlyWhenExact, storeRoute }) {
  let match = useRouteMatch({ path: to, exact: activeOnlyWhenExact });
  let matchTwo = useRouteMatch({ path: or, exact: activeOnlyWhenExact });
  const setHistory = () => { storeRoute.goTo(to); }

  const isSelected = (match || (matchTwo && matchTwo.isExact));

  return (
    <Link onClick={setHistory} style={{ textDecoration: `none`}} to={to}>
      <div className={`small-button sub-menu ${isSelected && `sub-menu-selected`} `} style={style}>
        <span className={`type-medium fz13`} >{label}</span>
      </div>
    </Link>
  )
}

ConnectedSubMenu.propTypes = {
  label: PropTypes.string.isRequired,
  style: PropTypes.object,
  to: PropTypes.string.isRequired,
  activeOnlyWhenExact: PropTypes.any
}

const SubMenu = connect(
  state => ({
    storeRoute: state.storeRoute
  })
)(ConnectedSubMenu);

export default SubMenu;
